<template>
  <v-snackbar
    v-model="isVisible"
    :timeout="notificationTimeout"
    location="bottom"
    :color="color"
    variant="flat"
  >
    <div class="d-flex align-center justify-space-between w-100">
      <span>{{ message }}</span>
      <v-btn icon="close" size="small" variant="text" @click="close" />
    </div>
  </v-snackbar>
</template>

<script>
import { mapGetters, mapActions } from "vuex";

export default {
  name: "AppNotifications",
  data() {
    return {
      isVisible: false,
    };
  },
  computed: {
    ...mapGetters("notifications", ["currentNotification"]),

    message() {
      const n = this.currentNotification;
      if (!n) return "";

      const key = n.i18nKey || "errors.generic";
      const params = n.i18nParams || {};
      return this.$t(key, params);
    },

    notificationTimeout() {
      const n = this.currentNotification;
      return (n && n.timeout) || 5000;
    },

    color() {
      const n = this.currentNotification;
      return n && n.type === "success" ? "success" : "error";
    },
  },
  watch: {
    currentNotification: {
      handler(newVal) {
        this.isVisible = !!newVal;
      },
      immediate: true,
    },
    isVisible(val) {
      if (!val) {
        this.clear();
      }
    },
  },
  methods: {
    ...mapActions("notifications", ["clear"]),
    close() {
      this.isVisible = false;
    },
  },
};
</script>

